import { render, staticRenderFns } from "./AddRecommenderModal.vue?vue&type=template&id=2bb4eb10"
import script from "./AddRecommenderModal.vue?vue&type=script&lang=ts"
export * from "./AddRecommenderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports